import { render } from "./ColumnsSelect.vue?vue&type=template&id=5e17a4ea"
import script from "./ColumnsSelect.vue?vue&type=script&lang=js"
export * from "./ColumnsSelect.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\ssradius\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__